import { FC, useEffect } from 'react'

import { Redirect } from 'react-router-dom'

import { authActions } from 'core/auth/authStore'

const Logout: FC = () => {
  useEffect(() => {
    authActions.logout()
  }, [])

  return <Redirect to='/' />
}

export default Logout
